import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76ed81e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "options-filter__block" }
const _hoisted_2 = { class: "options-filter__action-buttons" }
const _hoisted_3 = { class: "options-filter__apply-cancel-controls" }

import { FilterOptions, NamespaceModel, SelectedFilterOptions } from '../../models';
import { computed, PropType, ref, watch } from 'vue';
import { OptionFilterEnum } from './enums';
import OptionItemFilter from './components/OptionItemFilter.vue';
import { OptionItemModel } from './models';
import { ProjectModel } from '@/models';
import { TagModel } from '@/components/task-forms/models';
import { TypeModel } from '@/pages/namespace-types-settings-page/models';
import { GetDifficultyListItemDetail, ProjectQueueTaskListItem } from '../../adapter';
import { useRouter } from 'vue-router';
import { TirPmButton, TirPmButtonSizeEnum, TirPmButtonVariantEnum } from 'tir-components';

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'OptionsFilter',
  props: {
  /**Поле поиска */
  searchField: {
    type: String,
  },
  /**Применен фильтр */
  isApplyFilter: {
    type: Boolean,
  },
  /**Опции фильтра */
  filterOptions: {
    type: Object as PropType<FilterOptions>,
  },
  /**Выбранные элементы фильтра */
  selectedOptionsFilter: {
    type: Object as PropType<SelectedFilterOptions>,
  },
  /**Предыдущие значения фильтра*/
  previousFilterValues: {
    type: Object as PropType<SelectedFilterOptions>,
  },
  /**Не активна кнопка отмены фильтра */
  isDisabledCancelFilter: {
    type: Boolean,
  },
  /**изменился фильтр */
  isChangeGlobalStatus: {
    type: Boolean,
  },
  isChange: {
    type: Boolean,
  },
  /**опции фильтра которые не показывать */
  hidedOptionsFilter: {
    type: Array as PropType<OptionFilterEnum[]>,
  },
  /**показать только где я админ для проектов точно, для областей, для очередей ...' */
  showOnlyCurrentIsAdmin: {
    type: Boolean,
    required: false,
    default: true,
  },
},
  emits: ["toggleItem", "selectAllElements", "getWidthBlockSelectedElem", "searchElements", "scrollFinished", "getProjects", "getTagsProject", "getNamespacesProject", "getTypesNamespace", "getDifficultys", "getQueues", "getStatuses", "getPriorities", "setPreviousFilterValues", "cancelChangesFilter", "resetFilter"],
  setup(__props, { emit }) {

const props = __props;


/**События */


/**Был ли сброше фильтр */
const isResetFilter = ref(false);
/**Доступные фильтры при выборе проекта */
const availableFiltersProject = computed(() => {
  return props.selectedOptionsFilter.Projects.some((p) => p.Id !== 0)
    ? [OptionFilterEnum.Tags, OptionFilterEnum.Namespaces]
    : [];
});
/**Доступные фильтры при выборе НС */
const availableFiltersNamespace = computed(() => {
  return props.selectedOptionsFilter.Namespaces.some((p) => p.Id !== 0)
    ? [OptionFilterEnum.Types, OptionFilterEnum.Difficultys, OptionFilterEnum.Queues]
    : [];
});
/**Доступные фильтры при выборе очереди */
const availableFiltersQueue = computed(() => {
  return props.selectedOptionsFilter.Queues.some((p) => p.Id !== 0)
    ? [OptionFilterEnum.Statuses, OptionFilterEnum.Priorities]
    : [];
});
/**Опции */
const options = computed(() => {
  const computedOptions = [
    OptionFilterEnum.GlobalStatuses,
    OptionFilterEnum.Projects,
    ...availableFiltersProject.value,
    ...availableFiltersNamespace.value,
    ...availableFiltersQueue.value,
  ];

  return computedOptions.filter((option) => option !== null);
});
/**Не активное состояние кнопки Применить */
const isDisabledApply = computed(() => {
  const areArraysEqualById = (
    a: { Id: number | string }[] = [],
    b: { Id: number | string }[] = [],
  ) => a.length === b.length && a.every((itemA) => b.some((itemB) => itemA.Id === itemB.Id));

  const queuesChanged = !props.selectedOptionsFilter.Queues?.some((queue) => queue.Id);

  const allUnchanged = Object.values(OptionFilterEnum).every((key) =>
    areArraysEqualById(props.previousFilterValues[key], props.selectedOptionsFilter[key]),
  );
  return (
    (!isResetFilter.value && (queuesChanged || allUnchanged)) ||
    props.isChangeGlobalStatus ||
    props.isChange
  );
});
// && props.selectedOptionsFilter.Projects.length == 0;

watch(
  () => props.isChangeGlobalStatus,
  (newValue) => {
    console.log('isChangeGlobalStatus', newValue);
  },
);

/**Переключение чекбокса элемента*/
const toggleItem = (item: OptionItemModel, type: OptionFilterEnum, isMultiSelect: boolean) => {
  emit('toggleItem', item, type, isMultiSelect);
};
/**Переключение чекбокса выбора всех элементов*/
const selectAllElements = (type: OptionFilterEnum, isMultiSelect: boolean) => {
  emit('selectAllElements', type, isMultiSelect);
};
/**Применить фильтр */
const applyFilter = () => {
  emit('setPreviousFilterValues', props.selectedOptionsFilter, props.filterOptions);
};
/**Отменить изменения в фильтре */
const cancelChangesFilter = () => {
  emit('cancelChangesFilter');
};
/**Сбросить фильтр */
const resetFilter = () => {
  emit('resetFilter');
  if (props.isApplyFilter) {
    isResetFilter.value = true;
  }
};
const onChangeProject = (value) => {
  //
  emit('getProjects', props.selectedOptionsFilter.Projects);
  emit('getProjects', value);
};
/**Получить статусы */
const getStatuses = (statuses: OptionItemModel[], isGlobalStatusChanged: boolean) => {
  emit('getStatuses', statuses, isGlobalStatusChanged);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option) => {
      return (_openBlock(), _createBlock(OptionItemFilter, {
        option: option,
        filterOptions: __props.filterOptions,
        selectedOptionsFilter: __props.selectedOptionsFilter,
        showOnlyCurrentIsAdmin: __props.showOnlyCurrentIsAdmin,
        onGetWidthBlockSelectedElem: _cache[0] || (_cache[0] = ($event: any) => (emit('getWidthBlockSelectedElem', $event))),
        onSearchElements: ($event: any) => (emit('searchElements', $event, option)),
        onScrollFinished: _cache[1] || (_cache[1] = ($event: any) => (emit('scrollFinished', $event))),
        onGetTagsProject: _cache[2] || (_cache[2] = ($event: any) => (emit('getTagsProject', $event))),
        onGetQueues: _cache[3] || (_cache[3] = ($event: any) => (emit('getQueues', $event))),
        onGetStatuses: getStatuses,
        onGetNamespacesProject: _cache[4] || (_cache[4] = ($event: any) => (emit('getNamespacesProject', $event))),
        onGetProjects: onChangeProject,
        onToggleItem: toggleItem,
        onGetDifficultys: _cache[5] || (_cache[5] = ($event: any) => (emit('getDifficultys', $event))),
        onGetTypesNamespace: _cache[6] || (_cache[6] = ($event: any) => (emit('getTypesNamespace', $event))),
        onGetPriorities: _cache[7] || (_cache[7] = ($event: any) => (emit('getPriorities', $event))),
        onSelectAllElements: selectAllElements
      }, null, 8, ["option", "filterOptions", "selectedOptionsFilter", "showOnlyCurrentIsAdmin", "onSearchElements"]))
    }), 256)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(TirPmButton), {
          variant: _unref(TirPmButtonVariantEnum).PrimaryState,
          size: _unref(TirPmButtonSizeEnum).Small,
          isDisabled: isDisabledApply.value && !props.isChangeGlobalStatus && !props.isChange,
          onClick: applyFilter
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Применить ")
          ]),
          _: 1
        }, 8, ["variant", "size", "isDisabled"]),
        _createVNode(_unref(TirPmButton), {
          variant: _unref(TirPmButtonVariantEnum).SecondaryState,
          size: _unref(TirPmButtonSizeEnum).Small,
          isDisabled: __props.isDisabledCancelFilter,
          onClick: cancelChangesFilter
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Отмена ")
          ]),
          _: 1
        }, 8, ["variant", "size", "isDisabled"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_unref(TirPmButton), {
          variant: _unref(TirPmButtonVariantEnum).LinkState,
          size: _unref(TirPmButtonSizeEnum).Small,
          onClick: resetFilter
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Сбросить фильтр ")
          ]),
          _: 1
        }, 8, ["variant", "size"])
      ])
    ])
  ]))
}
}

})